import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { csrfFetch } from '../../store/csrf';
import './ImpersonationBanner.css';

// Persistent red banner while an admin is viewing the app as an employee.
// Rendered by App.js on every page whenever the session carries the
// impersonatedBy claim; exit restores the admin's own session cookie.
const ImpersonationBanner = () => {
  const user = useSelector((state) => state.users?.user);
  const [exiting, setExiting] = useState(false);

  if (!user?.impersonatedBy) return null;

  const exit = async () => {
    if (exiting) return;
    setExiting(true);
    try {
      await csrfFetch('/api/session/impersonate/exit', { method: 'POST' });
      // Full reload so the restored admin cookie drives everything.
      window.location.href = '/secure/employees';
    } catch (err) {
      setExiting(false);
      alert(err.data?.error || 'Could not exit impersonation — try logging out.');
    }
  };

  return (
    <div className="impersonation-banner" role="alert">
      <span className="impersonation-banner__text">
        👤 Viewing as <strong>{user.firstName} {user.lastName}</strong>
      </span>
      <button
        type="button"
        className="impersonation-banner__exit"
        disabled={exiting}
        onClick={exit}
      >
        {exiting ? 'Exiting…' : 'Exit impersonation'}
      </button>
    </div>
  );
};

export default ImpersonationBanner;
